import { useEffect, useState } from "react"
import styles from "../css/ItemView.module.css";
import EditIcon from '@mui/icons-material/Edit';
import { IconButton } from "@mui/material";

export default function ItemView(props) {
    const [seleccion, setSeleccion] = useState(0)


    return <div className={styles.cuerpo}>


        <div className={styles.foto}>
            <img
                src={props.url}
            />
        </div>
        <div className={styles.fotos}>
          
        </div>
        <div className={styles.descripcion}>
            {props.descripcion}
        </div>
        <div className={styles.nota}>
            {props.comentario}
        </div>
        <div className={styles.precios}>
            <div className={`${styles.precio1} ${parseFloat(props.precio) > 0 ? styles.oferta : ''}`}>
                {parseFloat(props.precioLista || "0.00").toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </div>
            <div className={styles.precio2}>
                {
                    parseFloat(props.precio) > 0 ?
                        parseFloat(props.precio || "0.00").toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : null
                }
            </div>
        </div>
    </div>
}